import { useContext } from "react";
import { PackagePickerAutonomousContext } from "../providers";
import { useQueryParams } from "./useQueryParams";
export const useSiteGuid = () => {
  const {
    siteGuid: contextSiteGuid
  } = useContext(PackagePickerAutonomousContext);
  const {
    siteGuid: querySiteGuid
  } = useQueryParams();
  return contextSiteGuid || querySiteGuid;
};
//# sourceMappingURL=useSiteGuid.js.map